export function stickyHeader() {

	let scrollHeight    = $(window).scrollTop();
	let header          = $('.js-page-header');

	if(scrollHeight < 100){
		header.removeClass('is-scrolled');
	} else {
		header.addClass('is-scrolled');
	}

	return 'stickyHeader';
}

export function menuButton() {

	let menuBtn     = $('.js-menu-button');
	let mobileMenu  = $('.js-mobile-menu');
	let closeMenu   = $('.js-close-menu');

	menuBtn.click(function() {
		mobileMenu.toggleClass('is-active');
	});

	closeMenu.click(function() {
		mobileMenu.toggleClass('is-active');
	});

	return 'menuButton';
}